<style scoped lang="less">
  .notificacao-titulo { font-size: 1.3em; }
  .notificacao-data { font-size: 1.1em; }
  .notificacao-mensagem { font-size: 0.9em; color: #777; font-style: italic; }

  .unread { font-weight: bold; font-size: 1.2em; }
  .read { color: #777; }
  .read td { font-size: 0.8em; }

  .h-loading .h-loading-circular {
    position: fixed;
  }
</style>

<style lang="less">
  .loading-scoped .h-loading .h-loading-circular {
    position: fixed;
  }
  @media (max-width: 515px) {
    .h-panel-btns .h-btn {
      width: 100%;
      margin: 4px 0;
    }
  }
  .h-layout { z-index: inherit; }
</style>

<template>
    <div class="app-form frame-page basic-form-vue">
        <div class="h-panel">
            <div class="h-panel-bar">
                <span class="h-panel-title">Notificações</span>
            </div>

            <div class="h-panel-body h-panel-btns loading-scoped">
              <Loading text="Loading" :loading="loading"></Loading>

              <p>
                <button :disabled="!acoes.arquivar" class="h-btn h-btn-green" title="arquivar mensagem" @click="arquivar()">
                  <i class="fas fa-inbox"></i>
                  <span>Arquivar</span>
                </button>

                <button :disabled="!acoes.lida" class="h-btn" title="marcar como lida" @click="marcarComoLida()">
                  <i class="fas fa-envelope-open"></i>
                  <span>Marcar como lida</span>
                </button>

                <button :disabled="!acoes.naoLida" class="h-btn" title="marcar como não lida" @click="marcarComoNaoLida()">
                  <i class="fas fa-envelope"></i>
                  <span>Marcar como não lida</span>
                </button>
              </p>

              <!--
  <div class="h-row">
    <div v-for="mensagem in mensagens" :class="getTrClass(mensagem)" >
      <p class="font-bold notificacao-titulo">
        <i v-if="mensagem.tipoAlerta === 'Informação'" class="h-icon-success"></i>
        <i v-if="mensagem.tipoAlerta === 2" class="h-icon-error"></i>
        <i v-if="mensagem.tipoAlerta === 3" class="h-icon-warn"></i>
        {{mensagem.titulo}}
      </p>
      <p class="notificacao-data">{{formatarData(mensagem)}}</p>
      <p class="notificacao-mensagem" v-html="mensagem.mensagem"></p>
      <p>
        <Button title="visualizar" class="h-btn h-btn-blue" @click="onTrdblclick(data)">
          <i class="fas fa-comment-dots"></i>
          visualizar notificação
        </Button>
      </p>
    </div>
  </div>
  -->

              <Table ref="table" @trdblclick="onTrdblclick" selectWhenClickTr :datas="mensagens" checkbox @select="onSelect" :getTrClass="getTrClass">
                <TableItem :width="700" title="mensagens">
                  <template slot-scope="{data}">
                    <p class="notificacao-titulo">{{data.titulo}}</p>

                    <p class="notificacao-data">{{formatarData(data)}}</p>

                    <p class="notificacao-mensagem" v-html="data.mensagem"></p>
                  </template>
                </TableItem>
                <TableItem :width="200">
                  <template slot-scope="{data}">
                    <Button title="visualizar" class="h-btn" @click="onTrdblclick(data)">
                      <i class="fas fa-comment-dots"></i>
                      Visualizar
                    </Button>
                  </template>
                </TableItem>
                <div slot="empty">Não existem mensagens</div>
              </Table>

            </div>
        </div>
    </div>
</template>
<script>

function marcarComoLidaOuNaoLida(mensagens, ids, lida) {
  mensagens.filter((value) => {
    return ids.filter(x => x === value._id).length > 0;
  }).forEach(v => { v.lida = lida; });
}

export default {
  data() {
    return {
      acoes: {
        lida: false,
        naoLida: false,
        arquivar: false
      },
      mensagens: [],
      file: [],
      loading: false
    };
  },
  mounted() {
    this.getAllMensagens();
  },
  methods: {
    onSelect(datas) {
      this.acoes.arquivar = datas.length > 0;
      const acoes = new Set(datas.map(x => x.lida));

      // se marcou alguma mensagem lida, libera o botão
      // true = mensagem lida
      this.acoes.naoLida = acoes.has(true);

      // se marcou alguma mensagem não lida, libera botão
      // false = mensagem não lida
      this.acoes.lida = acoes.has(false);
    },
    getTrClass(data, index) {
      return 'notificacao ' + (data.lida == true ? 'read' : 'unread');
    },
    onTrdblclick(data) {
      this.$router.push(`/notificacao/${data._id}`);
    },
    formatarData(data) {
      return Utils.formatDateTime(data.criadoEm);
    },
    getAllMensagens: async function () {
      const self = this;
      self.loading = true;

      const resp = await R.Notificacao.getAllMensagens();
      if (resp.ok == true) {
        self.mensagens = resp.data;
        self.$root.$emit('hook:update_mensagens');
      }

      self.loading = false;
    },
    arquivar() {
      const ids = Utils.getIdsTable(this.$refs.table);
      this.$Confirm(`Arquivar ${ids.length} mensagens?`, 'Arquivar')
        .then(async () => {
          this.loading = true;
          await R.Notificacao.arquivar(ids);
          this.$root.$emit('hook:update_mensagens');
          this.$Message.success('mensagens arquivadas');
          this.loading = false;

          this.getAllMensagens();
        })
        .catch(() => {
          this.$Message.error('operação cancelada');
        });
    },
    marcarComoLida: async function () {
      this.loading = true;

      const ids = Utils.getIdsTable(this.$refs.table);
      await R.Notificacao.marcarComoLida(ids);
      this.$root.$emit('hook:update_mensagens');
      marcarComoLidaOuNaoLida(this.mensagens, ids, true);

      this.loading = false;
    },
    marcarComoNaoLida: async function () {
      this.loading = true;

      const ids = Utils.getIdsTable(this.$refs.table);
      await R.Notificacao.marcarComoNaoLida(ids);
      this.$root.$emit('hook:update_mensagens');
      marcarComoLidaOuNaoLida(this.mensagens, ids, false);

      this.loading = false;
    }
  }
};
</script>
